import React from 'react';
import { buildCurrencyFormatter } from 'utils/helpers';

const getCurrencyValue = (value: number | string, currency?: string) => (
  <span>
    {buildCurrencyFormatter(currency).format(+value)}
  </span>
);

export default getCurrencyValue;
